import { MapPin, Tag } from '@phosphor-icons/react';

type TagOption = {
  id: string;
  name: string;
};

type MapSearchResultsProps = {
  places: any[];
  tags: TagOption[];
  t: any;
  onSelectPlace: (place: any) => void;
  onSelectTag: (tag: TagOption) => void;
  onShowAllPlaces: () => void;
};

const MAX_VISIBLE_PLACES = 5;
const MAX_VISIBLE_TAGS = 5;

export default function MapSearchResults({
  places,
  tags,
  t,
  onSelectPlace,
  onSelectTag,
  onShowAllPlaces,
}: MapSearchResultsProps) {
  const hiddenPlaceCount = Math.max(0, places.length - MAX_VISIBLE_PLACES);

  return (
    <div className="search-results" role="listbox">
      {!!tags.length && (
        <div className="search-tag-results" aria-label={t.tags}>
          {tags.slice(0, MAX_VISIBLE_TAGS).map((tag) => (
            <button
              type="button"
              className="search-tag-result"
              role="option"
              aria-selected={false}
              key={tag.id}
              onClick={() => onSelectTag(tag)}
            >
              <Tag weight="fill" />
              <span>{tag.name}</span>
            </button>
          ))}
        </div>
      )}
      {places.slice(0, MAX_VISIBLE_PLACES).map((place) => (
        <button
          type="button"
          role="option"
          aria-selected={false}
          key={place.id}
          onClick={() => onSelectPlace(place)}
        >
          <img src={place.image || '/place-placeholder.svg'} alt="" />
          <span><b>{place.name}</b><small>{place.address}</small></span>
          <MapPin />
        </button>
      ))}
      {hiddenPlaceCount > 0 && (
        <button type="button" className="search-more" onClick={onShowAllPlaces}>
          {hiddenPlaceCount} {hiddenPlaceCount === 1 ? t.moreResult : t.moreResults}
        </button>
      )}
      {!tags.length && !places.length && <div className="search-empty">{t.noMatches}</div>}
    </div>
  );
}
